
    <template>
      <section class="content element-doc">
        <h2 id="ri-qi-fan-wei-xuan-ze-qi"><a class="header-anchor" href="#ri-qi-fan-wei-xuan-ze-qi">¶</a> 日期范围选择器</h2>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/date-picker">element-ui </a> <code>el-date-picker</code> 组件文档</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<p>带默认快捷方式</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;ShDateRangePicker v-model=&quot;dateRange&quot; pickerOptions /&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        dateRange: []
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="zi-ding-yi-kuai-jie-fang-shi"><a class="header-anchor" href="#zi-ding-yi-kuai-jie-fang-shi">¶</a> 自定义快捷方式</h3>
<p>通过<code>pickerOptions</code>自定义快捷方式</p>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;ShDateRangePicker v-model=&quot;dateRange&quot; :picker-options=&quot;pickerOptions&quot; /&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        dateRange: []
      }
    },
    computed: {
      pickerOptions() {
        return {
          shortcuts: [
            {
              text: '最近两天',
              onClick(picker) {
                const startDate = new Date()
                const endDate = new Date()
                startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [startDate, endDate])
              }
            }
          ]
        }
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>value-format</td>
<td>返回值格式</td>
<td>String</td>
<td>YYYY-MM-dd</td>
</tr>
<tr>
<td>picker-options</td>
<td>配置项</td>
<td>Object</td>
<td>见示例</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ShDateRangePicker',{attrs:{"pickerOptions":""},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        dateRange: []
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ShDateRangePicker',{attrs:{"picker-options":_vm.pickerOptions},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        dateRange: []
      }
    },
    computed: {
      pickerOptions() {
        return {
          shortcuts: [
            {
              text: '最近两天',
              onClick(picker) {
                const startDate = new Date()
                const endDate = new Date()
                startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 1)
                picker.$emit('pick', [startDate, endDate])
              }
            }
          ]
        }
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  